module.exports = "query SportCategories($site: [String]) {\n  categories(site: $site, group: \"sportType\") {\n    id\n    title\n  }\n}"